<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapterhead" id="c02">CHAPITRE 2<br/>
ILS SONT FOUS, <br/>CES ADULTES!</h1>
<p class="indent">On dit que les adultes passent les deux premières années de la vie de leurs enfants à les encourager à marcher et à parler…</p>
<p class="image"><img alt="" src="OEBPS/images/11-1.png"/></p>
<p class="image"><img alt="" src="OEBPS/images/12-1.png"/></p>
<p class="indent">… et les seize années suivantes à les encourager à s’asseoir et à se taire.</p>
<p class="indent">C’est la même chose avec le petit pot. La plupart des adultes passent les premières années de la vie d’un enfant à discuter allègrement de pipi et de caca, à lui apprendre l’importance de mettre le pipi et le caca dans le petit pot, comme les grandes personnes.</p>
<p class="indent">Mais une fois que les enfants ont maîtrisé l’art de la propreté, on leur interdit aussitôt de parler de caca, pipi, toilette et autres sujets associés à la salle de bain. Tous ces mots sont soudain jugés vulgaires et impolis, et ne sont plus récompensés par des félicitations, des biscuits et des boîtes de jus.</p>
<p class="image"><img alt="" src="OEBPS/images/13-1.png"/></p>
<p class="indent">Un jour, tu es une vedette parce que tu as fait caca dans la toilette comme un grand garçon, et le lendemain, tu te fais envoyer au bureau du directeur parce que tu as dit le mot « caca » pendant le cours d’histoire (ce qui est pourtant un bon endroit pour dire ce mot).</p>
<p class="image"><img alt="" src="OEBPS/images/14-1.png"/></p>
<p class="image"><img alt="" src="OEBPS/images/14-2.png"/></p>
<p class="indent">Tu te demandes probablement pourquoi les adultes agissent ainsi. Pourquoi encouragent-ils quelque chose pour ensuite <em>l’interdire?</em></p>
<p class="indent">La seule réponse que je puisse trouver est que les adultes sont complètement <em>fous</em> et devraient être évités à tout prix. Peut-être as-tu la chance d’avoir trouvé quelques adultes en qui tu peux avoir confiance, mais tu seras sûrement d’accord si je te dis qu’en général, tu dois les avoir à l’œil.</p>
<p class="image"><img alt="" src="OEBPS/images/15-1.png"/></p>
<p class="indent">C’est justement ce que font Georges et Harold.</p>
<p class="image"><img alt="" src="OEBPS/images/16-1.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c02.vue?4d14e661